import React, { ErrorInfo } from 'react'

import { captureExceptionWithMessage } from 'utils/logRocket'

interface Props {
  children: React.ReactNode
  errorState: React.ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  public static getDerivedStateFromError() {
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    captureExceptionWithMessage('Error boundary hit', error, { componentStack: errorInfo.componentStack })
  }

  public render() {
    if (this.state.hasError) {
      return this.props.errorState
    }

    return this.props.children
  }
}
